<template>
  <div id="reservation-booked">
    <div id='booking-completed-message'>
      <span v-if="bookingCompletedMessage==null">
        Your online priority seating booking is complete.
      </span>

      <span v-if="bookingCompletedMessage">
        {{ bookingCompletedMessage }}
      </span>
    </div>
    <div id="confirmation-code">
      Confirmation Code: <span id="confirmation-code-highlight">{{ confirmationCode }}</span>
    </div>

    <div id="reservation-details-outer">
      <div id="reservation-details">
        <div id="reservation-details-header">Booking Details:</div>
        <div class="details-item details-item-full">
          <div id="details-address-label">
            <span class="details-label">Location:</span>
          </div>
          <div id="details-address">
            {{ addressLocation }}
          </div>
        </div>
        <div class="details-item details-item-half">
          <span class="details-label">Date:</span> {{ formattedDate }}
        </div>
        <div class="details-item details-item-half">
          <span class="details-label">Time:</span> {{ time }}pm
        </div>

        <div class="details-item details-item-half">
          <span class="details-label">Party Size:</span> {{ partySize }}
        </div>

        <div class="details-item details-item-half">
          <span class="details-label">First Name:</span> {{ firstName }}
        </div>

        <div class="details-item details-item-half">
          <span class="details-label">Last Name:</span> {{ lastName }}
        </div>

        <div class="details-item details-item-half">
          <span class="details-label">Email:</span> {{ email }}
        </div>

        <div class="details-item details-item-half">
          <span class="details-label">Phone:</span> {{ phone }}
        </div>

      </div>

      <div id="additional-details">

      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { moment } from 'moment'
import _ from 'lodash'

export default {
  name: 'reservationBooked',
  components: {

  },
  props: [ "bookingCompletedMessage" ],
  data() {
    return {

    }
  },
  computed: {
    ...mapState({
      location: state => state.availability.location,
      date: state => state.availability.date,
      partySize: state => state.availability.partySize,
      time: state => state.availability.suggestedTimes.selected || state.availability.suggestedTimes.requested,
      confirmationCode: state => state.userInfo.confirmationCode,
      firstName: state => state.userInfo.firstName,
      lastName: state => state.userInfo.lastName,
      phone: state => state.userInfo.phone,
      email: state => state.userInfo.email,
    }),
    formattedDate() {
      return this.date.format( 'ddd, MMMM D, YYYY' )
    },
    formattedLocation() {
      // return _.capitalize( this.location )
      if ( this.location == 'winston' ) {
        return 'Winston-Salem'
      } else {
        return 'Greensboro'
      }
    },
    addressLocation() {
      if ( this.location == 'winston' ) {
        return '2995 Bethesda Place, Winston-Salem, NC 27103'
      } else {
        return '1200 S. Holden Rd., Greensboro, NC 27407'
      }
    }
  },
  methods: {

  }

}

</script>

<style lang="scss" scoped>

.booked-label {

}

#reservation-booked {
}

#booking-completed-message {
  font-size: x-large;
  font-weight: bold;
}

#confirmation-code {
  font-size: larger;
  font-weight: bold;
}

#confirmation-code-highlight {
  color: #AD1313;
}

#reservation-details-outer {
  margin-top: 10px;
  margin-bottom: 50px;
}

#reservation-details {
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  width: 500px;
  font-size: 110%;

  @media screen and (max-width: 512px) {
    width: 100%;
  }
}

#reservation-details-header {
  font-weight: bold;
  font-size: larger;
}

#details-address-label {
  width: 70px;
  float: left;
}

#details-address {
  width: auto;
  float: left;

  @media screen and (max-width:512px) {
    width: 180px;
  }
}

.details-item-full {
  overflow: auto;
  padding-bottom: 15px !important;
}

.details-item {
  text-align: left;
  padding: 4px;

  @media screen and (max-width: 512px) {
    margin: 6px 0;
    width: 100% !important;
  }
}

.details-item-full {
  clear: left;
  width: 100%;
}

.details-item-half {
  width: 50%;
  float: left;
}



.details-label {
  font-weight: bold;
}

#additional-details {

}

</style>